import { render } from "./Timebox.vue?vue&type=template&id=09ef7276&ts=true"
import script from "./Timebox.vue?vue&type=script&lang=ts"
export * from "./Timebox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__